import React, { useContext } from 'react'
import { ThemeContext } from 'theme/ThemeProvider'
import DOMPurify from 'dompurify'

const MarkdownComponent = ({ markdown, style }: any) => {
	const { textw } = useContext(ThemeContext).theme.COLORS
	
	// HTML 태그와 스타일을 허용하도록 DOMPurify 설정 수정
	const sanitizedHtml = DOMPurify.sanitize(markdown, {
		ALLOWED_TAGS: ['strong', 'ul', 'li', 'ol', 'p', 'div', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'img', 'br', 'table', 'tr', 'td', 'th', 'thead', 'tbody'],
		ALLOWED_ATTR: ['style', 'class', 'id', 'href', 'src', 'alt', 'width', 'height', 'target', 'align', 'bgcolor', 'border', 'cellpadding', 'cellspacing'],
		ADD_TAGS: ['style'],
		ADD_ATTR: ['all'],
		WHOLE_DOCUMENT: false,
		RETURN_DOM: false,
		RETURN_DOM_FRAGMENT: false,
		FORCE_BODY: false,
	})

	return (
		<div
			className="markdown-content"
			style={{
				color: textw,
				width: '100%',
				...style
			}}
			dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
		/>
	)
}

export default MarkdownComponent
